import { render, staticRenderFns } from "./tabpage.vue?vue&type=template&id=5bd34ef1"
import script from "./tabpage.vue?vue&type=script&lang=js"
export * from "./tabpage.vue?vue&type=script&lang=js"
import style0 from "./tabpage.vue?vue&type=style&index=0&id=5bd34ef1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports